var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 23.734c0 .24.194.433.434.433h.8c.239 0 .433-.194.433-.433v-1.233a.833.833 0 0 1 .833-.834h5a.833.833 0 0 1 .834.834v1.233c0 .24.194.433.433.433h.8c.24 0 .433-.194.433-.433v-1.233a2.502 2.502 0 0 0-2.5-2.5h-5a2.503 2.503 0 0 0-2.5 2.5v1.233zm5-4.567a3.333 3.333 0 1 1 0-6.666 3.333 3.333 0 0 1 0 6.666zm0-5a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334zm1.119-6.616L1.952.884A.833.833 0 0 0 .884 1.952l6.667 18.333a.834.834 0 0 0 .77.549h.013a.833.833 0 0 0 .774-.524l3.201-8.002 8.002-3.2a.833.833 0 0 0-.025-1.558zm-8.929 3.341-.331.134-.133.332-2.522 6.306L3.06 3.061l14.603 5.31-6.307 2.521z",
    fill: "#FF7D0E",
    stroke: "#FF7D0E",
    strokeWidth: .433
  })));
};
export default __webpack_public_path__ + "static/media/nearby-location.2d84751a.svg";
export { SvgComponent as ReactComponent };